import { FunctionComponent } from 'react'

import styled from 'styled-components'

import useBlickPlusOnboardingTracking from '@hooks/useBlickPlusOnboardingTracking'
import useClientViewportType from '@hooks/useClientViewportType'
import useViewportTracking from '@hooks/useViewportTracking'
import AppPageDesktop from '@components/BlickPlusOnboardingModal/AppPage/AppPageDesktop'
import AppPageMobile from '@components/BlickPlusOnboardingModal/AppPage/AppPageMobile'

const Wrapper = styled.div``

const AppPage: FunctionComponent = () => {
  const clientViewportType = useClientViewportType()
  const { trackOnImpression } = useBlickPlusOnboardingTracking()

  const viewportRef = useViewportTracking({
    onImpression: trackOnImpression,
    track: true,
  })
  const isMobile = clientViewportType === 'mobile'
  return (
    <Wrapper ref={viewportRef}>
      {isMobile ? <AppPageMobile /> : <AppPageDesktop />}
    </Wrapper>
  )
}

export default AppPage
